import FaqEngenDynamic from "./FaqEngenDynamic";

export default FaqEngenDynamic;
